import { PcApiResponse } from '@/api/pc-api/types';
import { Price } from '@/api/pc-api/v2/{authInfoId}/price/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export const getPriceSet4 = (targetId: string) => {
  return api<PcApiResponse<Price>>('get', `/pc-api/v2/${PREFIX_PATH}/price/set4`, { targetId });
};
